import { privacyPolicyLink } from "../common/constants";

const learnMorePwdLessLink =
  'https://compass.t-mobile.com/compass?id=kb_article&sysparm_article=KB00107657';
const learnMoreIdpLink =
  'https://compass.t-mobile.com/compass?id=kb_article&sysparm_article=KB00108367';
const surveyLink = 'https://forms.office.com/r/sMcC90z85m?origin=lprLink';

const FooterLinks = (props)=> {
    const { user } = props;
return (
     <div className="link-container">
              {/* Links */}
              {!user.enforcedEnrollment && (
                <a
                  href={learnMorePwdLessLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="learn-more-pwd-less"
                >
                  Learn More About Passwordless
                </a>
              )}
              <a
                href={learnMoreIdpLink}
                target="_blank"
                rel="noopener noreferrer"
                className="learn-more-pwd-less"
              >
                Learn More About Identity Verification
              </a>

              <a
                href={privacyPolicyLink}
                target="_blank"
                rel="noopener noreferrer"
                className="learn-more-pwd-less"
              >
                Privacy Policy
              </a>
              {!user.enforcedEnrollment && (
                <a
                  href={surveyLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="survey"
                >
                  Identity Verification Enrollment Survey
                </a>
              )}
            </div>
)
};

export default FooterLinks;